module.exports = __webpack_public_path__ + "img/nabe_pc.c2e77994.jpg";